<script setup lang="ts">
import { ref, computed, inject } from "vue";
import SingleMetricWrapper from "@/modules/explorer/components/SingleMetric/SingleMetricWrapper.vue";
import { useExplorerStore } from "@/modules/explorer/store";
import DataViewTabs from "@/modules/explorer/components/DataViewTabs.vue";
import { ApiError, Result } from "@/api/base";
import { promptInvalidPermissions } from "@/api/helpers/loadingWrapper";
import { useApiClient } from "@/api/client";
const isLoading = ref(true);
const explorerStore = useExplorerStore();
import { useAbortController } from "@/modules/explorer/composables/useAbortController";
const { abortController, abortRequestAndResetController } =
	useAbortController();
import { processedDocument } from "chartjs-graph";
import { documentKey } from "@/modules/explorer/ExplorerUtils";
const injectedDocument = inject(documentKey);

const document = computed(() => {
	return injectedDocument?.value ?? explorerStore.document;
});

const fetchDataForSingleMetric = async (): Promise<Result<any, ApiError>> => {
	abortRequestAndResetController();

	return await promptInvalidPermissions(
		useApiClient("explorer").fetchDataForDocumentSingleMetric(
			processedDocument(document.value),
			"explorer/",
			abortController.value?.signal ?? null
		)
	);
};
</script>

<template>
	<v-card class="pa-2">
		<div class="d-flex flex-column align-end">
			<v-spacer />
			<data-view-tabs />
		</div>
		<div class="d-flex justify-center align-center pt-8 pb-14 px-10">
			<single-metric-wrapper
				@update:is-loading="(value) => (isLoading = value)"
				:last-updated="explorerStore.explorerState.lastUpdated"
				:fetch-data-for-single-metric="fetchDataForSingleMetric"
			/>
		</div>
	</v-card>
</template>

<style lang="scss" scoped></style>
